// extracted by mini-css-extract-plugin
export default {"icon_card":"icon_card-_IktT","label_wrap":"label_wrap-so9dd"};